(function (namespace, $) {
	"use strict";

	var AppResponse = function () {
		var o = this;

		$(document).ready(function () {
			o.initialize();
		});

		$(document).load(function () {
			o.loaded();
		});
	};

	var p = AppResponse.prototype;

	p._timeAux = 0;
	p._timeServer = 0;
	p._timeInternet = 0;
	p._timeBrowser = 0;

	p.initialize = function () {};

	p._microtime = function (getAsFloat) {
		var s, now;
		if (typeof performance !== "undefined" && performance.now) {
			now = (performance.now() + performance.timing.navigationStart) / 1e3;
			if (getAsFloat) {
				return now;
			}
			// Math.round(now)
			s = now | 0;
			return Math.round((now - s) * 1e6) / 1e6 + " " + s;
		} else {
			now = (Date.now ? Date.now() : new Date().getTime()) / 1e3;
			if (getAsFloat) {
				return now;
			}
			// Math.round(now)
			s = now | 0;
			return Math.round((now - s) * 1e3) / 1e3 + " " + s;
		}
	};

	p._generatePopover = function () {
		var o = this;
		jQuery('[data-content="tabs-pages-' + gpssat.AppPage._tabsActionId + '"] [data-toggle="popover-response"]').popover(
			{
				html: true,
				container: "body",
				trigger: "hover",
				title: "Tempo de resposta",
				content: function () {
					var timeTotal = o._timeServer + o._timeInternet + o._timeBrowser;

					var responseHtml =
						"<div class='col-md-12' style='border:1px solid #00b050; border-left: 10px solid #00b050; height: 25px; margin-bottom: 10px; border-radius: 3px; box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.33);'> ";
					responseHtml += "<div class='col-md-9'>Servidor</div>";
					responseHtml += "<div class='col-md-2'><b>";
					responseHtml += o._timeServer ? o._timeServer.toFixed(2) + "s" : "-";
					responseHtml += "</b></div>";
					responseHtml += "</div>";

					responseHtml +=
						"<div class='col-md-12' style='border:1px solid #f50000; border-left: 10px solid #f50000; height: 25px; margin-bottom: 10px; border-radius: 3px; box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.33);'> ";
					responseHtml += "<div class='col-md-9'>Internet</div>";
					responseHtml += "<div class='col-md-2'><b>";
					responseHtml += o._timeInternet ? o._timeInternet.toFixed(2) + "s" : "-";
					responseHtml += "</b></div>";
					responseHtml += "</div>";

					responseHtml +=
						"<div class='col-md-12' style='border:1px solid #0066cc; border-left: 10px solid #0066cc; height: 25px; margin-bottom: 10px; border-radius: 3px; box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.33);'> ";
					responseHtml += "<div class='col-md-9'>Navegador</div>";
					responseHtml += "<div class='col-md-2'><b>" + o._timeBrowser.toFixed(2) + "s</b></div>";
					responseHtml += "</div>";

					responseHtml +=
						"<div class='col-md-12' style='border:1px solid #ba6bfb; border-left: 10px solid #ba6bfb; height: 25px; margin-bottom: 10px; border-radius: 3px; box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.33);'> ";
					responseHtml += "<div class='col-md-9'>Total</div>";
					responseHtml += "<div class='col-md-2'><b>" + timeTotal.toFixed(2) + "s</b></div>";
					responseHtml += "</div>";

					return responseHtml;
				},
			},
		);
	};

	window.gpssat.AppResponse = new AppResponse();
})(window.gpssat, jQuery);
